import { buildDashboardUrl } from 'modules/white-label/utils/dashboard-url'

export const getLoginUrl = (locale: string) => `/${locale}/login`

export const getContactUrl = (contactId: string) =>
  buildDashboardUrl(`/dashboard/contacts/${contactId}`)
